import React from 'react';

import styles from './Error/Error.module.css';

const ThirdPartyCookiesHelp = () => {
  return (
    <div className={styles.errorMessage}>
      <span className={styles.errorMessageText}>
        Third‑party cookies are blocked in your browser, which prevents BoldSign from completing the connection inside HubSpot. Please enable third‑party cookies and try again.
      </span>
      <strong className={styles.sectionHeading}>Steps to allow third‑party cookies:</strong>
      <div className={styles.stepsBlock}>
        <ul className={styles.errorList}>
          <li>
            <strong>Chrome / Edge:</strong> Settings → Privacy → Cookies → Allow third‑party cookies
          </li>
          <li>
            <strong>Safari:</strong> Preferences → Privacy → Turn off “Prevent cross‑site tracking”
          </li>
        </ul>
      </div>
      <span className={styles.errorMessageText}>
        After updating the settings, refresh this page and connect BoldSign again.
      </span>
    </div>
  );
};

export default ThirdPartyCookiesHelp;
